import { render, staticRenderFns } from "./FornecedorModal.vue?vue&type=template&id=0d0b4915&scoped=true"
import script from "./FornecedorModal.vue?vue&type=script&lang=js"
export * from "./FornecedorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0b4915",
  null
  
)

export default component.exports